var PAProductCodes = ['PersonalAuto', 'personalAuto', 'auto_per'];

export default {
    normaliseProductCode: function normaliseProductCode(productCode) {
        if (PAProductCodes.includes(productCode)) {
            return 'PersonalAuto';
        }
        return productCode;
    },
    getLobSpecificKeyValue: function getLobSpecificKeyValue(key) {
        return key;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=PersonalAuto!./common/js/src/edge/endorsement/pa/PAProductCodeUtil.js
// module id = 444
// module chunks = 0